
// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import Picker from 'react-mobile-picker'
// import { EMPTY_OBJECT } from '../constants/globalConstants'
import { getConvertedDate } from '../utils/helper'
import '../global/CommonListModal.scss'
import { EMPTY_OBJECT } from '../constants/globalConstants'

function ScrollCalendar(props) {
    const [pickerDateValue, setPickerDateValue] = useState(null)
    const [btnDisabled, setBtnDisabled] = useState(true)
    const [pickerValue, setPickerValue] = useState({ date: '', hour: '', minutes: '', ampm: '' })
    const pickerRef = useRef(pickerValue)

    const { isPastCalenderOpenModal, setPastCalenderOpenModal, handlePastDateSelecter, isDateShow, extend, setSelectedPastDate, setResetPromo, selctedDateTime, openDateCalendar, selectedPastDateRef, partnerdetails, setselctedDateTime, selectedHours } = props

    const facilityLocData = JSON.parse(localStorage.getItem('faclityData')) || {}
    const timezone = facilityLocData?.facility?.timezone || 'America/New_York'
    const [today, setToday] = useState(null)
    const [currTime, setCurrTime] = useState(moment(new Date()).tz(timezone).format('YYYY-MM-DD HH:mm:ss'))
    // const today = extend ? moment(selectedPastDate).format('YYYY-MM-DD HH:mm:ss') : moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss')

    // Generate previous 30 days, excluding future days
    useEffect(() => {
        setToday(moment().format('YYYY-MM-DD HH:mm:ss'))
    }, [today])

    const getPreviousXDays = (days) => {
        const dayArr = []
        for (let i = 0; i < days; i++) {
            const date = moment(today).subtract(i, 'days')
            const formattedDate = i === 0 && !isDateShow ? `Today yearto ${date.year()}` : `${date.format('MMM DD')} yearto ${date.year()}`
            dayArr.push(formattedDate)
        }
        return dayArr
    }

    const days = getPreviousXDays(30)

    const getHours = () => Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'))
    const getMinutes = () => Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'))

    const selections = [
        { mapkey: days, val: 'date' },
        { mapkey: getHours(), val: 'hour' },
        { mapkey: getMinutes(), val: 'minutes' },
        { mapkey: ['AM', 'PM'], val: 'ampm' },
    ]

    // const formatPickerDate = (e) => {
    //     const datePart = e.date.includes('Today yearto') ? moment().tz(timezone).format('YYYY-MM-DD') : moment(e.date.split(' yearto ')[0], 'MMM DD').format('YYYY-MM-DD')
    //     const currentTimeInSeconds = moment().tz(timezone).format('ss')
    //     return `${datePart} ${e.hour}:${e.minutes}:${currentTimeInSeconds} ${e.ampm}`
    // }

    const handleCustomDatePicker = (e) => {
        const { curTime, formattedpickerDate } = getFormattedDateString(e)
        setPickerDateValue(formattedpickerDate)
        setBtnDisabled(moment(curTime).isSameOrBefore(formattedpickerDate, 'minutes'))  // Disable future dates
        setPickerValue(e)
    }

    const getFormattedDateString = (e) => {
        const curTime = moment(new Date()).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
        const dataString = new Date(e.date.split(' yearto ').join(' ').split(' ').join('-'))
        const currentTimeinSec = moment(new Date()).tz(timezone).format('ss')
        const pickerDate = `${e?.date?.includes('Today yearto') ?
            moment(new Date()).tz(timezone).set({
                hour: (e?.ampm == 'PM' && Number(e?.hour) == 12) ? '12' : (e?.ampm == 'PM') ? Number(Number(e?.hour) + 12).toFixed(0) : (e?.ampm == 'AM' && Number(e?.hour) == 12) ? '00' : e?.hour,
                minute: e?.minutes,
                second: '10'
            }
        ).format('YYYY-MM-DD hh:mm:ss A') : moment(dataString, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${e?.hour}:${e?.minutes}:${currentTimeinSec} ${e?.ampm}`
        const pickDt = moment(pickerDate, 'YYYY-MM-DD hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
        const formattedpickerDate = getConvertedDate(pickDt)

        return {
            curTime: curTime,
            formattedpickerDate: formattedpickerDate
        }
    }

    const handleClick = () => {
        const currentTimeDate = moment(new Date()).add(-1, 'minutes').tz(facilityLocData?.current?.facility?.timezone ? facilityLocData?.current?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
        const selectedTimeDate = moment(pickerDateValue).format('YYYY-MM-DD HH:mm:ss')
        setSelectedPastDate(pickerDateValue ? selectedTimeDate  : currentTimeDate)
        if(selectedPastDateRef?.current == null || selectedPastDateRef?.current) {
            selectedPastDateRef.current = pickerDateValue ? selectedTimeDate  : currentTimeDate
        }
        handlePastDateSelecter(pickerDateValue ? selectedTimeDate  : currentTimeDate)
        setPastCalenderOpenModal(false)
        setResetPromo(true)
        if(selctedDateTime?.active) {
            openDateCalendar(false, false)
        }
        const durationToAdd = moment.duration(selectedHours)
        const getDt = moment(pickerDateValue, 'YYYY-MM-DD HH:mm:ss').add(durationToAdd).format('YYYY-MM-DD HH:mm:ss')
        // const getTm = moment(pickerDateValue, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
        setselctedDateTime({
            ...selctedDateTime,
            dateUntill: getDt
        })
    }

    useEffect(() => {
        if (!extend) {
            if(pickerDateValue) {
                const pickerDtSet = moment(pickerDateValue)
                const pickerDate = `${moment(pickerDateValue).format('YYYY-MM-DD')} ${moment(pickerDtSet)?.format('hh')}:${moment(pickerDtSet)?.format('mm')}:${moment(pickerDtSet).format('A')}`
                const pickDt = moment(pickerDate, 'YYYY-MM-DD hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
                const formattedpickerDate = getConvertedDate(pickDt)
                setPickerDateValue(formattedpickerDate)
            } else {
                const pickerDtSet = moment(today).tz(timezone)
                setPickerValue({
                    date: `Today yearto ${pickerDtSet.year()}`,
                    hour: pickerDtSet.format('hh'),
                    minutes: pickerDtSet.format('mm'),
                    ampm: pickerDtSet.format('A'),
                })
            }
        }
    }, [isPastCalenderOpenModal])

    useEffect(() => {
        if (extend) {
            const currentDate = moment().tz(timezone)
            const pickerDtSet = moment(today).tz(timezone)
            const isAfterCurrentDate = pickerDtSet.isAfter(currentDate, 'days')
            setPickerValue({
                date: isAfterCurrentDate ? `${pickerDtSet.format('MMM DD')} yearto ${pickerDtSet.year()}` : `Today yearto ${pickerDtSet.year()}`,
                hour: pickerDtSet.format('hh'),
                minutes: pickerDtSet.format('mm'),
                ampm: pickerDtSet.format('A'),
            })
        }
    }, [today])
    useEffect(() => {
        pickerRef.current = pickerValue
    }, [pickerValue])

    useEffect(() => {
        if(pickerRef?.current) {
            const { formattedpickerDate } = getFormattedDateString(pickerRef?.current)
            setBtnDisabled(moment(currTime).isSameOrBefore(formattedpickerDate, 'minutes'))
        }
    }, [currTime])

    useEffect(() => {
        const Dtinterval = setInterval(() => {
            setCurrTime(moment(new Date()).tz(timezone).format('YYYY-MM-DD HH:mm:ss'))
        }, 1000)
    
        // Cleanup on component unmount
        return () => clearInterval(Dtinterval)
        
    }, [])

    return (
        <div>
            {pickerValue?.date && (
                <Modal show={isPastCalenderOpenModal} onHide={() => setPastCalenderOpenModal(false)} centered className="commonModalDialogbox" animation={false} >
                    <Modal.Header className="justify-content-around">
                        <div className='text-center'>
                            <h5 className="text-primary">Select Date & Time</h5>
                            {/* {(btnDisabled) ? <div className='text-danger'>Please choose an earlier date to pay for your past session.</div> : null} */}
                        </div>
                    </Modal.Header>
                    <Modal.Body className="scrollable-Modal">
                        <Picker wheel="normal" value={pickerValue} onChange={handleCustomDatePicker} option={pickerValue} >
                            {selections.map((selection, index) => (
                                <Picker.Column key={index} name={selection.val}>
                                    {selection?.mapkey.map((option) => (
                                        <Picker.Item key={option} value={option}>
                                            {option.split(' yearto ')[0]}
                                        </Picker.Item>
                                    ))}
                                </Picker.Column>
                            ))}
                        </Picker>
                    </Modal.Body>
                    <Modal.Footer className="flex-column">
                        <h6 className="border w-100 rounded p-2 text-center">
                            <div className="p-1"> Entry By -{' '}{pickerValue.date.includes('Today yearto') ? `${moment().tz(timezone).format('MMM DD, YYYY')} ${pickerValue.hour}:${pickerValue.minutes} ${pickerValue.ampm}` : `${pickerValue.date.split(' yearto ').join(', ')} ${pickerValue.hour}:${pickerValue.minutes} ${pickerValue.ampm}`}</div>
                        </h6>
                        <button
                            onClick={handleClick}
                            disabled={btnDisabled}
                            style={partnerdetails ? {
                                backgroundColor: partnerdetails?.brand_setting?.color,
                                color: '#fff', borderColor: partnerdetails?.brand_setting?.color
                            } : {}}
                            className={`${(btnDisabled) ? 'btn btn-secondary w-100 text-white' : 'btn btn-primary w-100 text-white'}`}
                        >Done</button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    )
}

ScrollCalendar.propTypes = {
    dispatch: PropTypes.func,
    isPastCalenderOpenModal: PropTypes.bool,
    setPastCalenderOpenModal: PropTypes.func,
    setSelectedPastDate: PropTypes.func,
    handlePastDateSelecter: PropTypes.func,
    setResetPromo: PropTypes.func,
    extend: PropTypes.bool,
    selectedPastDate: PropTypes.string,
    isDateShow: PropTypes.bool,
    selctedDateTime: PropTypes.object,
    openDateCalendar: PropTypes.func,
    selectedPastDateRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    partnerdetails: PropTypes.object,
    setselctedDateTime: PropTypes.func,
    selectedHours: PropTypes.string
}

ScrollCalendar.defaultProps = {
    dispatch: noop,
    isPastCalenderOpenModal: false,
    setPastCalenderOpenModal: noop,
    setSelectedPastDate: noop,
    handlePastDateSelecter: noop,
    setResetPromo: noop,
    extend: false,
    selectedPastDate: '',
    isDateShow: false,
    selctedDateTime: EMPTY_OBJECT,
    openDateCalendar: noop,
    selectedPastDateRef: null,
    partnerdetails: EMPTY_OBJECT,
    setselctedDateTime: noop,
    selectedHours: ''
}

function mapStateToProps({ transientReducer }) {
    return {
        selectedHours: transientReducer?.selectedHours
    }
}

export default connect(mapStateToProps)(ScrollCalendar)
